export const API = {
  BASE_URL: "https://www.omdbapi.com/?apikey=b4a06adc",
};
